<template>
  <a-row class="content-fix org">
    <a-row class="content-title" type="flex">
      <a-button
        type="primary"
        class="back-btn"
        @click="
          $router.push({
            name: 'activity'
          })
        "
      >
        <i class="t-transition icons icon-chevron-left" /> Назад
      </a-button>

      <a-row class="post-search" type="flex">
        <a-select
          v-model="perPage"
          class="table__parpage"
          option-filter-prop="children"
          placeholder="Все"
          @change="tableperPage"
        >
          <a-select-option
            v-for="(limit, index) in LimitList"
            :key="index"
            :value="limit.value"
          >
            {{ limit.title }}
          </a-select-option>
        </a-select>
        <a-button
          type="primary"
          class="all-news-btn"
          style="margin: 0 15px"
          @click="Allnews"
        >
          Все
        </a-button>
        <!-- <a-button type="primary" @click="createFunc()">
          <a-icon type="plus" />{{ $t("Add") }}
        </a-button> -->
      </a-row>

      <a-row type="flex" style="width: 100%; justify-content: space-between">
        <h1>{{ headTitle[0].title[$i18n.locale] }}</h1>
        <!-- <a-button
          :disabled="cardsIsEmpty"
          type="danger"
          @click="removeItem(selectedPosts)"
        >
          <a-icon class="action-btns" type="delete" /> {{ $t("Delete") }}
        </a-button> -->
      </a-row>
    </a-row>

    <a-table
      :columns="columns"
      :data-source="categoryProps.results || []"
      :loading="loading"
      :pagination="false"
      :scroll="{ x: 3000, y: 600 }"
      :row-key="(record) => record.id"
    >
      <!-- @click="
          $router.push({
            name: 'headquarters-update',
            params: { id: item.id }
          })
        " -->
      <template slot="id" slot-scope="item">
        <a-checkbox
          :checked="selectedPosts.includes(+item.id)"
          :value="+item.id"
          @change="toggleItemId(item.id)"
        />
        <span
          class="td-post-item"
          @click="
            $router.push({
              name: 'headquarters-update',
              params: { id: item.id, type: 0 }
            })
          "
        >
          <b>{{ item.id }}</b>
        </span>
      </template>

      <template slot="level" slot-scope="item">
        <a-input-number
          v-model="item.level"
          style="width: 60px"
          :min="1"
          @pressEnter="updatePosition(item, $event)"
        />
      </template>

      <template slot="photo" slot-scope="item">
        <!--<spinner v-if="loading" />-->
        <div v-if="!item.photo">no photo</div>
        <div v-else>
          <img
            style="width: 80px; height: 80px; object-fit: cover"
            alt="profile_img"
            :src="item.photo"
          />
        </div>
      </template>

      <template slot="activity_title" slot-scope="item">
        <div
          class="td-post-item"
          @click="
            $router.push({
              name: 'headquarters-update',
              params: { id: item.id, type: 0 }
            })
          "
        >
          <b>{{ item.title || "-" }}</b>
        </div>
      </template>

      <template slot="link" slot-scope="item">
        <a :href="item.url" target="_blank">{{ item.url }}</a>
      </template>

      <template slot="author" slot-scope="item">
        {{ item.author || "-" }}
      </template>

      <template slot="flayers" slot-scope="item">
        <a-button
          type="primary"
          style="width: 90%; background-color: #26a6de"
          @click="
            $router.push({
              name: 'ml-post',
              params: { act_id: item.id }
            })
          "
        >
          {{ $t("Add") }}
        </a-button>
      </template>

      <template slot="sub_content" slot-scope="item">
        <a-button
          type="primary"
          style="width: 90%; background-color: #26a6de"
          @click="openCreateModal(item.id)"
        >
          {{ $t("Add") }}
        </a-button>
      </template>

      <template slot="status" slot-scope="item">
        <!-- <osg-image :img="item" /> -->
        <a-tag :color="item.is_active ? 'geekblue' : 'volcano'">
          {{ item.is_active ? $t("Published") : $t("NotPublished") }}
        </a-tag>
      </template>

      <template slot="to_slider" slot-scope="item">
        <a-badge
          :status="item.on_slider ? 'success' : 'error'"
          :text="item.on_slider ? 'Да' : 'Нет'"
        />
      </template>

      <template slot="is_blog" slot-scope="item">
        <a-badge
          :status="item.is_blog ? 'success' : 'error'"
          :text="item.is_blog ? 'Да' : 'Нет'"
        />
      </template>

      <template slot="created_at" slot-scope="item">
        {{ moment(item.created_at).format("LLL") }}
      </template>

      <template slot="updated_at" slot-scope="item">
        {{ moment(item.updated_at).format("LLL") }}
      </template>

      <template slot="operation" slot-scope="item">
        <a-button
          type="primary"
          class="edit-btn"
          @click="
            $router.push({
              name: 'headquarters-update',
              params: { id: item.id, type: 0 }
            })
          "
        >
          <!--{{ $t("Edit") }}-->
          <a-icon class="action-btns" type="edit" />
        </a-button>
        <a-popconfirm
          cancel-text="Нет"
          ok-text="Да"
          title="Вы действительно хотите удалить?"
          @confirm="removeItem(item.id)"
        >
          <a-button style="margin-right: 10px" type="danger">
            <a-icon class="action-btns" type="delete" />
            <!--{{ $t("Delete") }}-->
          </a-button>
        </a-popconfirm>
      </template>
    </a-table>

    <a-row class="mt-1" style="padding-bottom: 15px">
      <a-pagination
        :key="perPage"
        :current="page"
        :default-page-size="perPage"
        :total="+categoryProps.count || 0"
        @change="toPage"
      />
    </a-row>

    <a-modal
      :visible="modalVisible"
      title="Добавить"
      :closable="false"
      style="max-height: 500px; max-width: 900px"
      width="900px"
    >
      <a-row align="middle" class="flex-baseline sm-mb">
        <a-col :span="6" style="text-align: right; padding-right: 8px">
          Язык:
        </a-col>
        <a-col :span="12">
          <a-row align="middle" class="flex-baseline flex-wrap">
            <lang-tabs v-model="langTab" class="mb-1x" />
          </a-row>
        </a-col>
      </a-row>
      <a-row align="middle" class="flex-baseline">
        <a-col :span="6" style="text-align: right; padding-right: 8px">
          Название:
        </a-col>
        <a-col :span="12" class="sm-mb">
          <a-input
            v-model="formOrgType[`title_` + langTab]"
            placeholder="Введите название"
          />
        </a-col>
      </a-row>
      <a-row align="middle" class="flex-baseline">
        <a-col :span="6" style="text-align: right; padding-right: 8px">
          Telephone:
        </a-col>
        <a-col :span="12" class="sm-mb">
          <a-input v-model="formOrgType.phone" placeholder="Введите email" />
        </a-col>
      </a-row>
      <a-row align="middle" class="flex-baseline">
        <a-col :span="6" style="text-align: right; padding-right: 8px">
          Email:
        </a-col>
        <a-col :span="12" class="sm-mb">
          <a-input v-model="formOrgType.email" placeholder="Введите email" />
        </a-col>
      </a-row>
      <template slot="footer">
        <a-button key="back" @click="modalVisible = false"> Закрыть </a-button>
        <a-button type="primary" @click="saveOrgType"> Сохранить </a-button>
      </template>
    </a-modal>
  </a-row>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      selectedRowKeys: [],
      selectedPosts: [],
      modalVisible: false,
      formOrgType: {
        activity: null,
        title_uz: "",
        title_oz: "",
        title_qr: "",
        title_en: "",
        title_ru: "",
        email: "",
        phone: ""
      },
      columns: [
        {
          title: "ID",
          key: "id",
          width: "90px",
          fixed: "left",
          scopedSlots: { customRender: "id" }
        },
        {
          title: this.$t("Order"),
          key: "level",
          width: "90px",
          fixed: "left",
          scopedSlots: { customRender: "level" }
        },
        {
          title: this.$t("TablePhoto"),
          key: "photo",
          width: "100px",
          fixed: "left",
          scopedSlots: { customRender: "photo" }
        },
        {
          title: this.$t("TableTitle"),
          key: "activity_title",
          width: "300px",
          fixed: "left",
          scopedSlots: { customRender: "activity_title" }
        },
        {
          title: "Основные направление",
          key: "flayers",
          width: "20%",
          scopedSlots: { customRender: "flayers" }
        },
        {
          title: "Мурожаат учун",
          key: "sub_content",
          width: "20%",
          scopedSlots: { customRender: "sub_content" }
        },
        {
          title: this.$t("Link"),
          key: "link",
          width: "40%",
          scopedSlots: { customRender: "link" }
        },
        {
          title: this.$t("Status"),
          key: "status",
          width: "20%",
          scopedSlots: { customRender: "status" }
        },
        {
          title: this.$t("OnSlider"),
          key: "to_slider",
          width: "20%",
          scopedSlots: { customRender: "to_slider" }
        },
        {
          title: "На блок",
          key: "is_blog",
          width: "20%",
          scopedSlots: { customRender: "is_blog" }
        },
        {
          title: this.$t("Author"),
          key: "author",
          width: "20%",
          scopedSlots: { customRender: "author" }
        },
        {
          title: this.$t("TableCreatedDate"),
          key: "created_datetime",
          width: "30%",
          scopedSlots: { customRender: "created_at" }
        },
        {
          title: this.$t("TableLastUpdatedDate"),
          key: "updated_datetime",
          width: "30%",
          scopedSlots: { customRender: "updated_at" }
        },
        {
          title: this.$t("TableAction"),
          key: "operation",
          fixed: "right",
          scopedSlots: { customRender: "operation" }
        }
      ],
      headTitle: [
        {
          title: {
            oz: "Основные направление",
            uz: "Основные направление",
            qr: "Основные направление",
            ru: "Основные направление",
            en: "Основные направление"
          }
        }
      ],
      search: "",
      categoryProps: {
        results: [],
        count: 0
      },
      LimitList: [
        {
          value: 10,
          title: "10"
        },
        {
          value: 20,
          title: "20"
        },
        {
          value: 40,
          title: "40"
        }
      ],
      langTab: $langPrefix,
      cardsIsEmpty: true,
      perPage: 20,
      page: 1,
      offset: 0
    }
  },
  computed: {
    getKey() {
      return this.langTab
    }
  },
  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },
  created() {
    this.formOrgType = {
      activity: this.$route.params.act_id,
      title_uz: "",
      title_ru: "",
      title_en: "",
      title_oz: "",
      title_qr: "",
      phone: "",
      email: ""
    }
  },
  methods: {
    async saveOrgType() {
      const createOrUpdate = {
        url: this.formOrgType.id
          ? `/admin/common/activity-contact/update/${this.formOrgType.activity}`
          : "/admin/common/activity-contact/create/",
        method: this.formOrgType.id ? "patch" : "post",
        data: this.formOrgType
      }
      try {
        // console.log(this.formOrgType)
        await this.$api[createOrUpdate.method](
          createOrUpdate.url,
          createOrUpdate.data
        ).then((res) => {
          // console.log(res)
          if (res.status === 200 || res.status === 201) {
            this.fetchData()
            this.modalVisible = false
          }
        })
      } catch (error) {
        this.$message.error("Ошибка при добавлении")
        console.error(error)
        this.modalVisible = false
      }
    },
    async updatePosition(item, event) {
      this.loading = true
      await this.$api
        .patch(`/admin/common/activity/${item.id}/update/`, {
          level: event.target.value
        })
        .then(() => {
          this.loading = false
          this.$message.success("Позиция обновлена")
          this.fetchData()
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    toggleItemId(itemId) {
      const f = this.selectedPosts.findIndex((item) => +item === +itemId)
      if (f !== -1) {
        this.selectedPosts.splice(f, 1)
        this.cardsIsEmpty = false
      } else {
        this.selectedPosts.push(itemId)
        this.cardsIsEmpty = false
      }

      if (this.selectedPosts.length === 0) {
        this.cardsIsEmpty = true
      }
    },
    tableperPage() {
      this.offset = 0
      this.fetchData()
    },
    async Allnews() {
      this.loading = true
      this.perPage = null
      this.categoryProps = {
        results: [],
        count: 0
      }
      try {
        const r = await this.$store.dispatch("activity/fetch", {
          type: this.$route.params.type
        })
        this.categoryProps.results = r
        this.categoryProps.count = r.count
        /*if (r) {
          this.$set(this, "categoryProps", {
            results: r || []
          })
        }*/
      } catch (e) {
        console.log(e)
        this.$sentry.captureMessage(e)
      }
      this.loading = false
    },
    toPage(arg) {
      this.$router.push({ query: { page: arg } })
    },
    SearchInput() {
      this.offset = 0
      this.fetchData()
    },
    async fetchData() {
      this.loading = true
      this.offset = +this.$route.query.page || 1
      this.page = this.offset
      this.offset = (this.offset - 1) * this.perPage
      try {
        const r = await this.$store.dispatch("activity/fetch", {
          limit: this.perPage,
          offset: this.offset
          // on_slider: true,
          // is_blog: true,
          // type: 0
        })
        if (r) {
          this.$set(this, "categoryProps", {
            results: r.results || [],
            count: r.count
          })
          this.loading = false
        }
      } catch (e) {
        console.log(e)
        this.$sentry.captureMessage(e)
      }
    },
    async removeItem(id) {
      if (Array.isArray(id)) {
        for (let i of id) {
          try {
            const res = await this.$store.dispatch("activity/deletePost", i)
            if (res && res.status === 204) {
              this.$message.success("Новости Успешно удалено")
            }
          } catch (e) {
            console.log(e)
            this.$sentry.captureMessage(e)
          }
        }
      } else {
        try {
          const res = await this.$store.dispatch("activity/deletePost", id)
          if (res && res.status === 204) {
            this.$message.success("Новости Успешно удалено")
          }
        } catch (e) {
          console.log(e)
          this.$sentry.captureMessage(e)
        }
      }
      await this.fetchData()
      this.selectedCards = []
      this.cardsIsEmpty = true
    },
    async createFunc() {
      await this.$router.push({
        name: "headquarters-create",
        params: {
          ...this.$route.params
        }
      })
    },
    async openCreateModal(act_id) {
      this.modalVisible = true
      try {
        let res = await this.$api.get(
          `/admin/common/activity-contact/update/${act_id}/`
        )
        if (res && res.data) {
          this.formOrgType = res && res.data
        } else {
          this.formOrgType = {
            activity: act_id,
            title_uz: "",
            title_ru: "",
            title_en: "",
            title_oz: "",
            title_qr: "",
            phone: "",
            email: ""
          }
        }
      } catch (error) {
        return error
      }
    }
  }
}
</script>
